import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LoadingShimmerComponent } from '../../../loading-shimmer/loading-shimmer.component';

@Component({
  selector: 'lib-readonly-form-field',
  imports: [MatIcon, LoadingShimmerComponent],
  templateUrl: './readonly-form-field.component.html',
  styleUrl: './readonly-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadonlyFormFieldComponent {
  label = input.required<string>();
  value = input.required<string | null | undefined>();
  hintText = input<string | null | undefined>();
  trailingIconName = input<string | null | undefined>();
  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  trailingIconClick = output<void>();
}
